"use client";

import { useEnvironmentInfo } from "@/hooks/useEnvironmentInfo";

export function TopBarEnvironmentBadge() {
  const { data } = useEnvironmentInfo();
  const environment = data?.environment;

  if (!environment || environment.toLowerCase() === "production") {
    return null;
  }

  const label = environment.toLowerCase() === "development" ? "DEV" : environment.toUpperCase();

  return (
    <span
      aria-label={`API environment: ${environment}`}
      className="ml-[var(--space-xs)] rounded-[var(--radius-sm)] px-[6px] py-[1px] text-[10px] font-bold uppercase leading-[14px] tracking-[0.12em] text-white"
      style={{ backgroundColor: "var(--token-surface-danger)" }}
    >
      {label}
    </span>
  );
}
